
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.032 6.435a.5.5 0 01.5-.5H9.19a.5.5 0 010 1H3.532a.5.5 0 01-.5-.5zM3.032 8.947a.5.5 0 01.5-.5H9.19a.5.5 0 010 1H3.532a.5.5 0 01-.5-.5zM3.032 11.46a.5.5 0 01.5-.5H9.19a.5.5 0 010 1H3.532a.5.5 0 01-.5-.5z","fill":"#4D4D4D"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 .672a.5.5 0 01.5-.5h7.54a.5.5 0 01.349.141l3.77 3.666a.5.5 0 01.151.359V15.33a.5.5 0 01-.5.5H.5a.5.5 0 01-.5-.5V.672zm1 .5V14.83h10.31V4.549L7.837 1.172H1z","fill":"#4D4D4D"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.033.172a.5.5 0 01.5.5v3.27h3.27a.5.5 0 010 1h-3.77a.5.5 0 01-.5-.5V.672a.5.5 0 01.5-.5z","fill":"#4D4D4D"}})])
          )
        }
      }
    